import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { toJS } from "mobx";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import { SHOP_MULTILPE } from "npmlinks-constants";
import ProductItem from "../ProductItem";
import ShopAllStylesCarousels from "../ShopAllStylesCarousels";
import AddToBagActions from "../AddToBagActions";
import { ToCurrency } from "../../../utils";

@inject("ProductStore")
@observer
class ShopAllStylesView extends Component {
  constructor() {
    super();
    this.state = {
      list: [],
      currentIndex: 0,
      loadingIndex: -1,
    };
    this.init = this.init.bind(this);
    this.toggleSelection = this.toggleSelection.bind(this);
    this.updateSku = this.updateSku.bind(this);
    this.updateQty = this.updateQty.bind(this);
    this.updateStyle = this.updateStyle.bind(this);
  }
  componentDidMount() {
    this.init();
  }
  get currentSelected() {
    const { list } = this.state;
    return list.filter(item => item.isSelected);
  }
  get imageList() {
    return (
      this.state.list.map(item => item && item.images && item.images[0]) || []
    );
  }
  get currentAmount() {
    const { list } = this.state;
    return list
      .filter(product => product.isSelected)
      .map(product => {
        const priceFromSelection =
          (product.selectedSku && product.selectedSku.price) || 0;
        const selectedQty = product.selectedQty || 1;
        const totalPriceFromSelection = priceFromSelection * selectedQty;
        const defaultPrice =
          (product.sellingPriceRange && product.sellingPriceRange.max) || 0;
        return totalPriceFromSelection || defaultPrice;
      })
      .reduce((a, b) => a + b, 0);
  }

  init() {
    const { data } = this.props;
    const list =
      (data &&
        toJS(data).map(item => {
          const newItem = item;
          newItem.isSelected = item.inStock;
          return newItem;
        })) ||
      [];
    this.setState({ list });
  }

  toggleSelection(index) {
    const { list } = this.state;
    if (list[index].inStock) {
      list[index].isSelected = !list[index].isSelected;
      this.setState({ list });
    }
  }
  updateSku(data, sku) {
    const { list } = this.state;
    const index = list.findIndex(item => item.styleId === data.styleId);
    list[index].selectedSku = sku;
    this.setState({ list });
  }
  updateQty(data, qty) {
    const { list } = this.state;
    const index = list.findIndex(item => item.styleId === data.styleId);
    list[index].selectedQty = qty;
    this.setState({ list });
  }
  updateStyle(data, styleId) {
    const { list } = this.state;
    const index = list.findIndex(item => item.styleId === data.styleId);
    this.setState({ loadingIndex: index });
    this.props.ProductStore.getDetails(styleId, false).then(
      response => {
        const { mainStyle, colors } = response;
        const finalData = {
          ...mainStyle,
          ...colors,
          ...{ isSelected: mainStyle.inStock },
        };
        list[index] = finalData;
        this.setState({ currentIndex: index, loadingIndex: -1, list });
      },
      () => {
        this.setState({ currentIndex: index, loadingIndex: -1 });
        console.log("error occured in updating syles for shop all");
      },
    );
  }
  get title() {
    const { title } = this.props;
    return {
      text: title.text,
      style: title.color ? { color: title.color } : {},
    };
  }
  render() {
    const { list, currentIndex, loadingIndex } = this.state;
    const { closeModal } = this.props;
    return (
      <GridContainer className="nw-shopallstyles-viewcontainer">
        <GridRow>
          <GridColumn className="nwc-grid-col-sm-6 nw-shopallstyles-titlecontainer">
            <h3 style={this.title.style} className="nw-shopallstyles-title">
              {this.title.text}
            </h3>
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-6 nw-shopallstyles-productcount">
            {this.currentSelected.length}
            {(this.currentSelected.length === 1 &&
              SHOP_MULTILPE.SHOP_ALL_STYLES.PRODUCT_COUNT_TEXT.replace(
                "$plural",
                "",
              )) ||
              SHOP_MULTILPE.SHOP_ALL_STYLES.PRODUCT_COUNT_TEXT.replace(
                "$plural",
                "s",
              )}
          </GridColumn>
        </GridRow>
        <GridRow className="nw-shopallstyles-contentrow">
          <GridColumn className="nwc-grid-col-sm-6 nw-desktop-only">
            <ShopAllStylesCarousels.component
              data={this.imageList}
              index={currentIndex}
            />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-6">
            <GridRow className="nw-shopallstyles-productitemcontainer nwc-custom-scrollbar">
              {list &&
                list.map((item, index) => (
                  <GridColumn className="nwc-grid-col-sm-6 ">
                    <ProductItem.component
                      data={item}
                      index={index}
                      toggleSelection={() => {
                        this.toggleSelection(index);
                      }}
                      updateSku={this.updateSku}
                      updateQty={this.updateQty}
                      updateStyle={this.updateStyle}
                      loadingIndex={loadingIndex}
                      closeModal={closeModal}
                    />
                  </GridColumn>
                ))}
            </GridRow>
          </GridColumn>
        </GridRow>
        <GridRow className="nw-shopallstyles-actionsrow">
          <GridColumn className="nwc-grid-col-sm-7 nw-shopallstyles-actionstotal">
            {SHOP_MULTILPE.SHOP_ALL_STYLES.TOTAL_TEXT}
            <span className=" nw-shopallstyles-totalamount">
              {ToCurrency(this.currentAmount)}
            </span>
          </GridColumn>
          <AddToBagActions.component data={list} closeModal={closeModal} />
        </GridRow>
      </GridContainer>
    );
  }
}

ShopAllStylesView.propTypes = {
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.shape([]).isRequired,
  ProductStore: PropTypes.shape({
    getDetails: PropTypes.func.isRequired,
  }).isRequired,
};
const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ShopAllStylesView,
  component: ShopAllStylesView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/ShopAllStylesView/index.js